import React from 'react';
/* Il foglio lo importa il COMPONENTE, non le schermate che lo usano.
   Lasciarlo a loro e' gia' costato: il 18 settembre 2026 la schermata
   Consensi e' finita in produzione con l'intestazione senza stile,
   perche' nessuno importava questo file e il bundle non lo conteneva.
   Chi aggiunge l'intestazione a una schermata non deve ricordarsi di
   niente. */
import '../../styles/IntestazioneSezione.css';

/**
 * IntestazioneSezione — l'intestazione delle schermate con sotto-viste.
 *
 * PERCHE' UN COMPONENTE E NON DIECI COPIE
 * Lo schema è: etichetta della sezione in alto, piccola e in maiuscolo;
 * titolo grande sotto; le linguette delle sotto-viste a destra sulla
 * stessa riga del titolo; l'azione principale all'estrema destra.
 * Scritto a mano su otto schermate diventa otto spaziature leggermente
 * diverse, e il giorno che si cambia una misura se ne aggiornano sei su
 * otto — le due dimenticate restano lì per mesi.
 *
 * LE LINGUETTE NON SI TRONCANO MAI.
 * Su schermo stretto vanno a capo, e se non bastano scorrono in
 * orizzontale. Troncarle vorrebbe dire nascondere una sotto-vista senza
 * dirlo: chi non la vede non sa che esiste, e non e' come una colonna
 * tagliata in una tabella, dove almeno si intuisce che manca qualcosa.
 *
 * NESSUN COLORE SCRITTO QUI. Tutto dai token del tema — e comunque il
 * controllo che gira prima della build rifiuterebbe un valore a mano.
 *
 * @param {string}  etichetta  la riga piccola in alto (es. «Amministrazione»)
 * @param {string}  titolo     il titolo grande
 * @param {node}    icona      icona facoltativa accanto al titolo
 * @param {string}  sottotitolo riga di spiegazione sotto il titolo
 * @param {array}   viste      [{ chiave, etichetta, contatore }]
 * @param {string}  vista      la chiave della sotto-vista attiva
 * @param {func}    onVista    (chiave) => void
 * @param {node}    azione     il pulsante principale, all'estrema destra
 */
export default function IntestazioneSezione({
    etichetta, titolo, icona, sottotitolo,
    viste = [], vista, onVista, azione,
}) {
    return (
        <header className="int-sezione">
            {etichetta && <p className="int-etichetta">{etichetta}</p>}

            <div className="int-riga">
                <h1 className="int-titolo">
                    {icona}
                    {titolo}
                </h1>

                <div className="int-destra">
                    {viste.length > 0 && (
                        /* `role="tablist"` non e' decorazione: senza, chi usa
                           un lettore di schermo sente una fila di pulsanti
                           senza capire che sono alternative fra loro. */
                        <div className="int-viste" role="tablist" aria-label="Sotto-viste">
                            {viste.map((v) => (
                                <button
                                    key={v.chiave}
                                    role="tab"
                                    aria-selected={vista === v.chiave}
                                    className={`int-vista${vista === v.chiave ? ' attiva' : ''}`}
                                    onClick={() => onVista && onVista(v.chiave)}
                                >
                                    {v.etichetta}
                                    {typeof v.contatore === 'number' && (
                                        <span className="int-contatore">{v.contatore}</span>
                                    )}
                                </button>
                            ))}
                        </div>
                    )}
                    {azione && <div className="int-azione">{azione}</div>}
                </div>
            </div>

            {sottotitolo && <p className="int-sottotitolo">{sottotitolo}</p>}
        </header>
    );
}
